export const IsRelatedSuggestion = (v) => {
    if (typeof v !== 'object' || v === null)
        return false;
    const obj = v;
    if (typeof obj.sourceEntityType !== 'string')
        return false;
    if (typeof obj.sourceEntityRecordId !== 'string')
        return false;
    if (!Array.isArray(obj.relatedItems))
        return false;
    // TODO:厳密化する
    // https://break-tmc.atlassian.net/browse/CREW-4249
    for (const elem of obj.relatedItems) {
        if (typeof elem.entityType !== 'string')
            return false;
        if (typeof elem.entityRecordId !== 'string')
            return false;
        if (typeof elem.title !== 'string')
            return false;
        if (typeof elem.updatedBy !== 'object' || elem.updatedBy === null)
            return false;
        if (typeof elem.updatedAt !== 'string')
            return false;
    }
    return true;
};
